import type { CheckoutLocationState } from '@jane/shared-ecomm/providers';

export const isReturningFromAuth = (state: CheckoutLocationState | null) =>
  Boolean(
    state?.externalAuthReturn ||
    state?.preAuthCustomer ||
    state?.preAuthOptions ||
    state?.preAuthSelection
  );
